import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { Box, type SxProps } from "@mui/material";
import { isEmpty } from "lodash-es";
import type { FC } from "react";
import { EDITOR_THEME } from "../message/editor/theme/theme";
import type { SerialisedEditorDesign } from "../message/editor/types/serialised-editor-design";
import { $loadDesign } from "../message/editor/utils/load-design";
import { EDITOR_NODES } from "../message/editor/utils/nodes";
import { tableNodeReplacement } from "../message/editor/utils/use-styleable-columns";

export const ReadOnlyEditor: FC<{
  design: SerialisedEditorDesign;
  format: "email" | "chat" | "sms";
  sx?: SxProps;
  fullWidth?: boolean;
}> = ({ design, format, sx, fullWidth }) => {
  if (isEmpty(design)) {
    return null;
  }
  const headerAndEditor = (
    <Box
      sx={{
        ...sx,
        margin: "0px auto",
      }}
    >
      <RichTextPlugin
        placeholder={() => null}
        ErrorBoundary={LexicalErrorBoundary}
        contentEditable={
          <ContentEditable className="editor-content read-only" data-testid="read-only-editor" />
        }
      />
    </Box>
  );

  const wrapper = fullWidth ? (
    <Box sx={{ ...sx, width: "100%", p: 0, m: 0 }}>{headerAndEditor}</Box>
  ) : (
    headerAndEditor
  );

  return (
    <LexicalComposer
      key={JSON.stringify(design)}
      initialConfig={{
        editorState: $loadDesign(design),
        editable: false,
        namespace: "ce",
        onError: console.error,
        nodes: tableNodeReplacement(EDITOR_NODES[format]),
        theme: EDITOR_THEME,
      }}
    >
      {wrapper}
    </LexicalComposer>
  );
};
